export default function Plus() {
  return (
    <svg
      width="24"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line
        x1="14.9453"
        y1="2.42841e-08"
        x2="14.9453"
        y2="30"
        stroke="currentColor"
      />
      <line
        x1="30"
        y1="13.832"
        x2="-2.11507e-08"
        y2="13.832"
        stroke="currentColor"
      />
    </svg>
  );
}
